/**
 * The AutoTemplated editor, ported into MAS.
 *
 *   /editor/template/:id  edit a MAS template
 *   /editor/design/:id    edit one History design
 *
 * The editor code in ./pages/TemplateEditor.jsx is AutoTemplated's own, cut
 * down to the Data fields / Text / Elements / Images / Background tabs. Its
 * styles (editor.css) are scoped under .at-editor so they don't touch the
 * rest of MAS.
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import TemplateEditor from './pages/TemplateEditor.jsx';
import './editor.css';
import './editor-mas.css';

export default function MasEditorPage({ mode }) {
  const { id } = useParams();
  return (
    <div className="at-editor at-editor-page" data-theme="light">
      <main>
        {/* key: switching documents remounts the editor (it initialises once) */}
        <TemplateEditor key={`${mode}:${id}`} mode={mode} />
      </main>
    </div>
  );
}
